module.exports = __webpack_public_path__ + "static/materiel-medical-74b9fd6e388f9f8ccca97fd85b9a8859.jpg";